import { IAdHocAudience, DeliveryOption } from '../../../lib/types/communication.types';
import { IComposePanelFields } from './compose-panel.types';

export const buildEmptyAudience = (): IAdHocAudience => ({
  ageGroupIds: [],
  playerAssessmentIds: []
});

export const buildInitialValues = (): IComposePanelFields => ({
  title: '',
  deliveryOption: DeliveryOption.EMAIL_ONLY,
  subject: '',
  bodyHtml: '',
  smsBody: '',
  audience: buildEmptyAudience(),
  contexts: []
});

// Derives plaintext from Quill HTML for the server's plaintext body and the Yup
// not-empty check. DOMParser/regex-fallback rationale: ComposePanel/README.md.
export const stripHtml = (html: string): string => {
  if (!html) return '';
  if (typeof window !== 'undefined' && typeof window.DOMParser !== 'undefined') {
    const doc = new window.DOMParser().parseFromString(html, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  }
  return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
};
